export default {
  // FrontPage.vue
  frontPageRequirementTitle: 'ของฉัน',
  frontPageProvideTitle: 'เสนอ',
  frontPagePersonalCenterTitle: 'โปรไฟล์',
  login: 'เข้าสู่ระบบ',
  home_chatWithOctopie: 'กำลังทำความเข้าใจความคิดของคุณ',
  home_chatNeedUnderstood: 'เข้าใจความคิดของคุณแล้ว',
  home_draftBannerTitle: 'เขียนข้อความของคุณให้เสร็จ',
  home_draftBannerSubtitle: 'AI จัดเตรียมข้อความของคุณไว้แล้ว — แตะเพื่อดำเนินการต่อ',
  home_tabHome: 'หน้าแรก',

  // App.vue
  appRequirementTitle: 'เราใส่ใจทุกคำแนะนำและข้อเสนอแนะ',
  appRequirementBtn: 'ส่ง',
  appSubmitSuccess: 'ส่งสำเร็จ ขอบคุณสำหรับข้อเสนอแนะ',
  appFeedbackLink: 'ข้อเสนอแนะ/ติชม',
  mobile_banner_text: 'เพื่อประสบการณ์ที่ดีที่สุด ใช้แอปของเรา',
  mobile_banner_btn: 'รับแอป',

  // Common
  loading: 'กำลังโหลด...',
  confirm: 'ยืนยัน',
  cancel: 'ยกเลิก',
  save: 'บันทึก',
  delete: 'ลบ',
  edit: 'แก้ไข',
  add: 'เพิ่ม',
  search: 'ค้นหา',
  refresh: 'รีเฟรช',
  change_batch: 'สับเปลี่ยน',
  back: 'ย้อนกลับ',
  submit: 'ส่ง',
  close: 'ปิด',
  ok: 'ตกลง',
  yes: 'ใช่',
  no: 'ไม่',
  send: 'ส่ง',
  block: 'บล็อก',
  more: 'เพิ่มเติม',
  logout: 'ออกจากระบบ',
  settings: 'การตั้งค่า',
  view_guide: 'ดูคู่มือ',
  feedback: 'ข้อเสนอแนะ',
  feedback_title: 'ข้อเสนอแนะ',
  feedback_new: 'ข้อเสนอแนะใหม่',
  feedback_empty: 'ยังไม่มีข้อเสนอแนะ',
  feedback_hint: 'บอกเราหน่อยว่าคิดอย่างไร...',
  feedback_submit: 'ส่ง',
  feedback_submit_success: 'ส่งข้อเสนอแนะสำเร็จ',
  feedback_submit_failed: 'ส่งข้อเสนอแนะไม่สำเร็จ',
  feedback_reply_label: 'คำตอบจากแพลตฟอร์ม',
  register: 'ลงทะเบียน',
  name: 'ชื่อ',
  email: 'อีเมล',
  mobile: 'เบอร์โทรศัพท์',
  password: 'รหัสผ่าน',
  verification_code: 'รหัสยืนยัน',
  company_name: 'Beijing Liangshao Technology Co., Ltd.',
  all_rights_reserved: 'สงวนลิขสิทธิ์',
  footerVersion: 'เวอร์ชัน {version}',
  copy: 'คัดลอก',
  regenerate: 'สร้างใหม่',
  generate: 'สร้าง',
  contact_now: 'แชท',
  yours: 'คุณ',
  xiaoyao_analysis: 'การวิเคราะห์โดย AI',
  brand_name: 'OctoSay',
  anonymous: 'ไม่ระบุตัวตน',
  no_summary: 'ไม่มีสรุป',
  file: 'ไฟล์',
  discover: 'สำรวจ',
  discover_title: 'สำรวจ',
  discover_hotChannels: 'แชนเนลยอดนิยม',
  discover_allChannels: 'ทั้งหมด',
  discover_searchChannel: 'ค้นหาแชนเนล',
  discover_noChannels: 'ไม่พบแชนเนล',

  // Messages
  operationSuccess: 'ดำเนินการสำเร็จ',
  operationFailed: 'ดำเนินการล้มเหลว',
  networkError: 'เครือข่ายมีปัญหา กรุณาลองอีกครั้งภายหลัง',
  dataLoadingFailed: 'โหลดข้อมูลไม่สำเร็จ',
  noData: 'ไม่มีข้อมูล',
  deleteConfirm: 'แน่ใจหรือไม่ว่าต้องการลบ?',
  saveConfirm: 'แน่ใจหรือไม่ว่าต้องการบันทึก?',

  // Form Validation
  required: 'ช่องนี้จำเป็นต้องกรอก',
  emailInvalid: 'กรุณากรอกที่อยู่อีเมลที่ถูกต้อง',
  phoneInvalid: 'กรุณากรอกเบอร์โทรศัพท์ที่ถูกต้อง',
  passwordTooShort: 'รหัสผ่านต้องมีอย่างน้อย {min} ตัวอักษร',
  passwordMismatch: 'รหัสผ่านทั้งสองไม่ตรงกัน',

  // Time
  today: 'วันนี้',
  yesterday: 'เมื่อวาน',
  justNow: 'เมื่อสักครู่',
  minutesAgo: '{min} นาทีที่แล้ว',
  hoursAgo: '{hour} ชั่วโมงที่แล้ว',
  daysAgo: '{day} วันที่แล้ว',

  // Footer
  about: 'เกี่ยวกับ',
  footerPrivacy: 'นโยบายความเป็นส่วนตัว',
  footerTerms: 'ข้อกำหนดการใช้งาน',
  footerSupport: 'ช่วยเหลือและสนับสนุน',

  // Register
  registerAgeConfirm: 'ฉันยืนยันว่าอายุ 13 ปีขึ้นไป',
  registerAgeConfirm18: 'ฉันยืนยันว่าฉันมีอายุอย่างน้อย 18 ปี',
  registerTermsPrefix: 'ฉันได้อ่านและยอมรับ',
  registerTermsAnd: 'และ',
  registerAgeError: 'กรุณายืนยันอายุของคุณ',
  registerTermsError: 'กรุณายอมรับข้อกำหนดและนโยบายความเป็นส่วนตัว',

  // Chat
  chatPrivacyTip: 'พิมพ์ข้อความใน hub AI จะคุยกับคุณก่อนเพื่อเคลียร์รายละเอียด เมื่อคุณยืนยัน ข้อความและสรุปของ AI จะถูกโพสต์พร้อมกัน แล้ว AI จะจับคู่ให้อย่างต่อเนื่อง',
  aiChat_quickSuggestions: 'ลองพูดแบบนี้',
  aiChat_welcome: "สวัสดี! บอกหน่อยว่ากำลังมองหาอะไรอยู่",

  // Chat - AI Progress Steps (new)
  aiChat_readyToPost: 'เข้าใจรายละเอียดแล้ว — โพสต์เพื่อหาคู่ของคุณ',
  aiChat_readyToPostHint: 'คุยต่อเพื่อเพิ่มรายละเอียดหรืออัปเดตสรุปได้ทุกเมื่อ',
  aiChat_progressStep1: 'ทำความเข้าใจรายละเอียด',
  aiChat_progressStep1Done: 'เข้าใจรายละเอียดแล้ว',
  aiChat_progressStep2: 'สรุปโดย AI',
  aiChat_progressStep2Desc: 'AI สร้างสรุปเพื่อการจับคู่',
  aiChat_progressStep3: 'โพสต์ลง กลุ่ม',
  aiChat_progressStep3Desc: 'โพสต์และหาคู่ของคุณ',
  aiChat_publishExtraHint: 'พิมพ์ข้อความที่อยากพูดกับสมาชิกใน hub',
  aiChat_publishMsgRequired: 'จำเป็น',
  aiChat_publishMsgLabel: 'ข้อความของคุณถึง hub',
  aiChat_matchSummaryLabel: 'สรุปโดย AI',

  ai_generated_label: 'AI Generated',

  ai_content_disclaimer: 'เนื้อหาต่อไปนี้สร้างโดย AI สำหรับอ้างอิงเท่านั้น',
  aiChat_publishSuggestionHint: 'แตะเพื่อแทนที่',
  aiChat_allowDirectContact: 'อนุญาตให้ติดต่อโดยตรง',
  aiChat_allowDirectContactDesc: 'ผู้อื่นสามารถติดต่อคุณโดยตรงได้โดยไม่ต้องจับคู่',
  channel_chat_session_publishToChannel: 'โพสต์ลง กลุ่ม Octo',
  aiChat_newChat: 'รีเซ็ต',

  // Channels / กลุ่ม
  home_tabChannels: 'กลุ่ม Octo',
  channels_title: 'กลุ่ม Octo',
  channels_myChannels: 'กลุ่ม ที่เข้าร่วม',
  channels_discover: 'สำรวจ',
  channels_noChannels: 'ยังไม่มี hub',
  channels_noMyGroupsTitle: 'คุณยังไม่ได้เข้าร่วม hub ใดเลย',
  channels_noMyGroupsSubtitle: 'ค้นหา hub เพื่อเข้าร่วมและเริ่มสร้างความสัมพันธ์',
  channels_searchGroupsBtn: 'ค้นหา กลุ่ม',
  channels_loginPrompt: 'เข้าสู่ระบบเพื่อดู hub',
  channels_create: 'สร้าง กลุ่ม Octo',
  channels_search: 'ค้นหา กลุ่ม Octo',
  channels_searchMyGroups: 'ค้นหา กลุ่ม Octo ของฉัน',
  channels_searchHint: 'ค้นหา',
  channels_searchHintChats: 'ค้นหาแชท...',
  channels_searchHintGroups: 'ค้นหา hub...',
  channels_searchHintMy: 'ค้นหา hub ที่เข้าร่วม...',
  channels_joinByCode: 'เข้าร่วมด้วยรหัส',
  channels_joinByCodeTitle: 'เข้าร่วม กลุ่ม Octo ด้วยรหัส',
  channels_joinByCodeHint: 'กรอกรหัส กลุ่ม Octo',
  channels_joinByCodeConfirm: 'เข้าร่วม',
  channels_joinByCodeNotFound: 'ไม่พบ hub',
  channels_createNewGroup: 'สร้าง กลุ่ม Octo ใหม่',
  channels_noResults: 'ไม่พบ hub',
  channel_detail_join: 'เข้าร่วม',
  channel_detail_leave: 'ออก',
  channel_detail_members: 'สมาชิก',
  // 聚合进群消息 banner（joinMsgs）
  channelJoinMsg_oneJoined: '{name} เข้าร่วมแล้ว',
  channelJoinMsg_twoJoined: '{name1} และ {name2} เข้าร่วมแล้ว',
  channelJoinMsg_multiJoined: '{name1}, {name2} และอีก {n} คนเข้าร่วมแล้ว',
  channelJoinMsg_oneAndMoreJoined: '{name} และอีก {n} คนเข้าร่วมแล้ว',
  channelJoinMsg_membersJoined: '{n} คนเข้าร่วมแล้ว',

  // Feed
  channels_feed: 'แชท',
  channels_groups: 'กลุ่ม',
  feed_related: 'ที่เกี่ยวข้อง',
  feed_recommend: 'แนะนำ',
  feed_empty: 'ยังไม่มีฟีด ลองไปเยี่ยมชม hub ยอดนิยม',
  feed_goToGroup: 'ดูใน hub',
  feed_joinGroupAndSendMsg: 'เข้าร่วม hub และส่งข้อความ',
  channel_detail_channelCode: 'รหัส กลุ่ม Octo',
  channel_detail_invitePhrase: 'คำเชิญเข้าร่วม "{name}"\nรหัสเชิญ {code} — เปิดแอปเพื่อเข้าร่วมอัตโนมัติ · AI ช่วยเคลียร์รายละเอียดก่อน แล้วหาคนที่ใช่ให้คุณ',
  channel_detail_post: 'โพสต์ลง กลุ่ม',
  channel_detail_aiHint: "พิมพ์ข้อความใน hub แล้ว AI จะเคลียร์รายละเอียดให้ก่อน",
  channel_input_hint: 'พูดอะไรสักอย่าง...',
  channel_leave_confirm_message: 'แน่ใจหรือไม่ว่าต้องการออกจาก hub นี้? คุณจะไม่ได้รับข้อความจาก hub อีก',
  channel_invite_notFound: 'ไม่พบ hub หรือลิงก์หมดอายุ',
  channel_invite_joinBtn: 'ดาวน์โหลดแอป OctoSay',
  channel_invite_hint: 'ดาวน์โหลดแอป แล้วสแกน QR Code นี้หรือค้นหาชื่อ hub เพื่อเข้าร่วม',
  channel_invite_globalHintTitle: 'คุณกำลังจะดาวน์โหลดเวอร์ชัน Global',
  channel_invite_globalHintIOS: 'แอปนี้อาจไม่มีใน App Store ประเทศจีน กรุณาเปลี่ยนไปใช้ Apple Store ภูมิภาคอื่นแล้วค้นหา OctoSay หรือดาวน์โหลด APK โดยตรงด้านล่าง',
  channel_invite_globalHintAndroid: 'Google Play อาจเข้าถึงไม่ได้ในภูมิภาคของคุณ แนะนำให้ดาวน์โหลด APK โดยตรง หรือลอง Google Play',
  channel_invite_globalHintDefault: 'แอปอาจไม่มีใน app store ท้องถิ่น แนะนำให้ดาวน์โหลด APK โดยตรง หรือลอง App Store',
  channel_invite_globalBtnAppStore: 'ไปที่ App Store',
  channel_invite_globalBtnGooglePlay: 'ไปที่ Google Play',
  channel_invite_globalBtnAPK: 'ดาวน์โหลด APK โดยตรง',
  channel_invite_defaultDesc: 'เข้าร่วม {name} บน OctoSay',
  share: 'แชร์',
  share_channel: 'แชร์ กลุ่ม',
  share_channel_link: 'แชร์ลิงก์',
  channel_detail_inviteCode: 'รหัสเชิญ',
  channel_detail_copyLink: 'คัดลอกลิงก์',
  share_session_title: 'โพสต์บน OctoSay',
  share_match_title: 'แมตช์บน OctoSay',
  share_session_text: '{userName}: {summary}',
  share_session_text_no_summary: 'ดูว่า {userName} โพสต์อะไรบน OctoSay',
  session_share_notFound: 'ไม่พบโพสต์หรือลิงก์หมดอายุ',
  session_share_fromChannel: 'จาก กลุ่ม Octo',
  session_share_downloadBtn: 'ดาวน์โหลดแอป OctoSay',
  session_share_hint: 'ดาวน์โหลดแอปเพื่อดูโพสต์เต็มและเข้าร่วม hub',
  session_share_openInApp: 'เปิดในแอป',
  toast_link_copied: 'คัดลอกลิงก์แล้ว',
  toast_no_share_data: 'ไม่มีอะไรให้แชร์',
  channels_joinByQR: 'QR Code',
  channels_joinByQRWebHint: 'เว็บไม่รองรับการสแกน QR กรุณากรอกรหัส hub เพื่อเข้าร่วม',
  channels_joinByQRTitle: 'เข้าร่วมด้วย QR Code',
  channel_detail_qrCode: 'QR Code',
  channel_detail_qrCodeSave: 'บันทึกรูป',
  channel_detail_qrCodeSaveHint: 'คลิกขวาที่รูปเพื่อบันทึก',
  channel_detail_qrCodeSaved: 'บันทึกลงอัลบั้มแล้ว',
  channel_detail_qrCodeSaveFailed: 'บันทึกไม่สำเร็จ กรุณาลองอีกครั้ง',
  channel_detail_locateFailed: 'ระบุตำแหน่งข้อความไม่สำเร็จ',
  channel_detail_locateError: 'เกิดข้อผิดพลาดในการระบุตำแหน่งข้อความ',
  channel_detail_myMessages: 'ข้อความของฉัน',
  channel_detail_searchMessages: 'ค้นหาข้อความ',
  channel_detail_aiChat: 'แชทกับ AI',
  channel_detail_matchHistory: 'ประวัติการจับคู่',
  channel_create_title: 'สร้าง กลุ่ม Octo',
  channel_create_name: 'ชื่อ กลุ่ม Octo',
  channel_create_description: 'คำอธิบาย',
  channel_create_submit: 'สร้าง',
  channelCreate_aiAssist: 'AI จะช่วยคุณสร้าง hub ที่เหมาะสม',
  channelCreate_nameHint: 'กรอกชื่อ hub ของคุณ',
  channelCreate_descHint: 'อธิบายว่า hub ของคุณเกี่ยวกับอะไร',
  channelCreate_creating: 'กำลังสร้าง...',
  channelCreate_created: 'สร้าง hub แล้ว!',
  channelCreate_failed: 'สร้าง hub ไม่สำเร็จ',
  channelCreate_welcomeMsg: "สวัสดี! ฉันอยู่ที่นี่เพื่อช่วยคุณสร้าง hub บอกฉันว่าคุณอยากได้ hub แบบไหน — ชื่อ หัวข้อ หรือจุดประสงค์ — แล้วฉันจะเรียบเรียงเป็นชื่อ hub และคำแนะนำ hub พร้อมสร้างรูปโปรไฟล์ให้",
  channelCreate_aiHint: 'เขียนหัวข้อ hub ของคุณ...',
  channelCreate_clarifyingProgress: 'กำลังจัดระเบียบหัวข้อ hub ของคุณ...',
  channelCreate_readyToCreate: 'พร้อมสร้าง กลุ่ม Octo',
  channelCreate_step1: 'อธิบายหัวข้อ',
  channelCreate_step1Done: 'ไอเดียชัดเจนแล้ว',
  channelCreate_step2: 'สร้าง กลุ่ม Octo',
  channelCreate_confirmBtn: 'ยืนยันการสร้าง',
  channelCreate_publicNotice: 'กลุ่ม เป็นพื้นที่สาธารณะสำหรับผู้ที่มีความสนใจร่วมกันมาพบปะและเชื่อมต่อกัน แพลตฟอร์มอาจจัดการ อัปเดต หรือรวม hub ตามความจำเป็น อย่าลังเลที่จะแชร์ hub นี้ให้คนอื่นที่อาจสนใจ',
  channelCreate_similarGroupsTitle: 'พบ กลุ่ม Octo ที่คล้ายกัน',
  channelCreate_similarGroupsDesc: 'กลุ่ม เหล่านี้อาจตรงกับสิ่งที่คุณต้องการ',
  channelCreate_exactMatchHint: 'มี hub ชื่อนี้อยู่แล้ว!',
  channelCreate_joinHint: 'กลุ่ม ที่มีอยู่เหล่านี้อาจเหมาะกับคุณ',
  channelCreate_joinExisting: 'เข้าร่วม กลุ่ม Octo ที่มีอยู่',
  channelCreate_stillCreate: 'ยังคงสร้าง กลุ่ม Octo ใหม่',
  channel_chat_session_comments: 'ความคิดเห็น',
  channel_chat_session_commentHint: 'เขียนความคิดเห็น...',
  channel_chat_session_sendComment: 'ความคิดเห็น',
  channel_chat_session_loadMore: 'โหลดเพิ่มเติม',
  channel_chat_session_noComments: 'ยังไม่มีความคิดเห็น',
  channel_chat_session_deleteComment: 'ลบ',
  channelSearch_title: 'ค้นหาใน กลุ่ม',
  channelSearch_placeholder: 'ค้นหาข้อความ...',
  channelSearch_onlyMine: 'เฉพาะโพสต์ของฉัน',
  channelSearch_tabAllMessages: 'ข้อความใน กลุ่ม',
  channelSearch_tabMyMessages: 'ข้อความของฉัน',
  chatMsgSearch_placeholder: 'ค้นหาข้อความ',
  chatMsgSearch_tabMsgs: 'ข้อความ',
  chatMsgSearch_tabContacts: 'รายชื่อติดต่อ',
  chatMsgSearch_emptyPrompt: 'พิมพ์คำค้นหาเพื่อค้นหาข้อความ',
  chatMsgSearch_tooShort: 'พิมพ์อย่างน้อย 2 ตัวอักษรเพื่อค้นหา',
  chatMsgSearch_contactEmptyPrompt: 'พิมพ์ชื่อผู้ใช้หรืออีเมลเพื่อค้นหารายชื่อติดต่อ',
  chatMsgSearch_noContacts: 'ไม่พบรายชื่อติดต่อที่ตรงกัน',
  chatMsgSearch_inChatPlaceholder: 'ค้นหาในแชทนี้',
  channelHistory_title: 'ประวัติ',
  channelHistory_myMessages: 'ข้อความของฉัน',
  channelHistory_loadMore: 'โหลดเพิ่มเติม',
  channel_settings_push: 'การแจ้งเตือน กลุ่ม Octo',
  channel_settings_commentPush: 'การแจ้งเตือนความคิดเห็น',
  channel_settings_likePush: 'การแจ้งเตือนการกดไลก์',
  channel_settings_receiveNotifications: 'รับการแจ้งเตือน',
  channel_settings_directContact: 'อนุญาตให้ติดต่อโดยตรง',
  session_published: 'เผยแพร่แล้ว',
  session_publishFailed: 'เผยแพร่ไม่สำเร็จ',
  session_setDirectContactSuccess: 'บันทึกการตั้งค่าแล้ว',
  session_setDirectContactFailed: 'บันทึกการตั้งค่าไม่สำเร็จ',
  session_setPrivate: 'ตั้งเป็นส่วนตัว',
  session_setPublic: 'ตั้งเป็นสาธารณะ',
  session_pauseMatching: 'หยุดจับคู่ชั่วคราว',
  session_resumeMatching: 'จับคู่ต่อ',
  session_matchPausedToast: 'หยุดจับคู่ชั่วคราวแล้ว',
  session_matchResumedToast: 'กลับมาจับคู่ต่อแล้ว',
  match_matchingPausedTitle: 'การจับคู่หยุดชั่วคราว',
  match_reasonTag: 'เหตุผลการจับคู่',
  match_matchingPausedHint: 'เปิดจับคู่ใหม่ได้ทุกเมื่อ',
  session_confirmSetPrivate: 'ตั้งเนื้อหานี้เป็นส่วนตัว? ผู้ใช้อื่นจะไม่สามารถดูได้',
  session_messageIsPrivate: 'ข้อความนี้เป็นข้อความส่วนตัว',
  chatSessionComment_replyHint: 'เขียนความคิดเห็น...',
  chatSessionComment_reply: 'ความคิดเห็น',
  chatSessionComment_count: '{n} ความคิดเห็น',
  chatSessionMatch_count: '{n} แมตช์',
  chatSessionComment_replyTo: 'ตอบกลับ',
  chatSessionComment_inputHint: 'เขียนความคิดเห็น...',
  chatSessionComment_send: 'ส่ง',
  chatSessionComment_delete: 'ลบ',
  chatSessionComment_deleteConfirm: 'แน่ใจหรือไม่ว่าต้องการลบความคิดเห็นนี้?',
  chatSessionComment_loadMore: 'โหลดเพิ่มเติม',
  chatSessionComment_noMore: 'ไม่มีความคิดเห็นเพิ่มเติม',
  chatSessionComment_loginToComment: 'เข้าสู่ระบบเพื่อแสดงความคิดเห็น',
  chatSessionComment_viewEarlier: 'ดูการตอบกลับก่อนหน้า {n} รายการ',
  chatSessionLike_like: 'ถูกใจ',
  chatSessionLike_liked: 'ถูกใจแล้ว',
  chatSessionLike_count: 'ถูกใจ',
  chatSessionBookmark_bookmark: 'บุ๊กมาร์ก',
  chatSessionBookmark_bookmarked: 'บุ๊กมาร์กแล้ว',
  chatSessionMatch_viewMatches: 'ดูแมตช์',
  chatSessionMatch_matchHistory: 'ประวัติการจับคู่',
  chatSessionMatch_noMatches: 'ยังไม่มีแมตช์',
  channel_match_achievement: 'มีโพสต์จับคู่สำเร็จ {count} รายการ',
  channel_match_achievement_view: 'ดู →',
  channel_matchHistory_title: 'ประวัติการจับคู่ของแชนเนล',
  chatSessionMatch_matchedAt: 'จับคู่เมื่อ {time}',
  discover_userMsgLabel: 'ผู้ใช้พูดว่า',
  common_loading: 'กำลังโหลด...',
  common_sending: 'กำลังส่ง...',
  common_error: 'ข้อผิดพลาด',
  common_success: 'สำเร็จ',
  common_me: 'ฉัน',

  // Chat - Set Public / Pick Location
  aiChat_clarifyingProgress: "AI กำลังเคลียร์ความต้องการของคุณเพื่อให้ทุกข้อความที่โพสต์ได้ผลจริง หลังโพสต์ AI จะหาคู่ที่ใช่ให้อย่างต่อเนื่อง",
  aiChat_clarifyingAlmostDone: 'เกือบเสร็จแล้ว กรุณายืนยัน',
  aiChat_clarifyingOneMore: 'เหลืออีกประมาณ 1 คำถาม แล้วคุณจะโพสต์ได้',
  aiChat_clarifyingRemaining: 'เหลืออีกประมาณ {count} รอบ ใกล้เสร็จแล้ว',
  aiChat_clarifyingEvaluating: 'กำลังประเมินความคืบหน้า...',
  aiChat_setPublicMatch: 'ตั้งเป็นสาธารณะและจับคู่',
  aiChat_needsClarifiedPublic: "ฉันเข้าใจคุณแล้ว เมื่อคุณยืนยันและโพสต์ AI จะหาคู่ให้คุณต่อเนื่อง\nเล่ารายละเอียดเพิ่มได้ทุกเมื่อ",
  aiChat_needsClarifiedPrivate: 'เข้าใจแล้ว! ตั้งเป็นสาธารณะเพื่อให้ฉันหาคู่ต่อไป!\nเล่ารายละเอียดเพิ่มได้ทุกเมื่อ',
  aiChat_setPublicTitle: 'ตั้งเป็นสาธารณะ',
  aiChat_setPublicMessage: 'เนื้อหาของคุณจะแสดงต่อผู้อื่น เพื่อให้ OctoSay หาคู่ที่เข้ากันได้\n\nข้อมูลที่จะถูกแชร์:\n• ชื่อผู้ใช้และรูปโปรไฟล์\n• สรุปเนื้อหา\n• เนื้อหาการสนทนา (แสดงในสำรวจ)\n\nตั้งกลับเป็นส่วนตัวได้ทุกเมื่อ',
  aiChat_findMatches: 'ดูผลการจับคู่',
  aiChat_publishing: 'กำลังโพสต์...',
  aiChat_matchSectionTitle: 'ข้อความของคุณเหมาะกับกลุ่มเหล่านี้ที่สุด แตะเพื่อโพสต์',
  aiChat_joinedBadge: 'เป็นสมาชิกแล้ว',
  aiChat_matchSectionEmpty: 'ยังไม่มีกลุ่มที่ตรงกันพอ — คุณสร้างกลุ่มใหม่เพื่อโพสต์ได้เลย',
  aiChat_suggestPublishCreateNew: 'สร้างกลุ่มใหม่',
  aiChat_repickChannel: 'เปลี่ยนกลุ่ม',
  aiChat_creatingChannelTitle: 'ไม่พบกลุ่มที่เหมาะสม กำลังสร้างให้คุณ',
  aiChat_creatingChannelHint: 'AI กำลังสร้างกลุ่มตามความต้องการของคุณ เสร็จแล้วโพสต์ต่อได้เลย ปกติใช้เวลา 10-30 วินาที',
  aiChat_publishToChannelHint: 'จะโพสต์ลง "{name}"',
  aiChat_pickChannelTitle: 'เลือกกลุ่มที่จะโพสต์',
  aiChat_matchingChannelTitle: 'กำลังค้นหากลุ่มที่เหมาะกับคุณ',
  aiChat_matchingChannelHint: 'AI กำลังค้นหาจากความต้องการของคุณ โดยปกติใช้เวลาไม่กี่วินาทีถึงครึ่งนาที',
  aiChat_matchUnavailableTitle: 'ขณะนี้ยังแสดงคำแนะนำไม่ได้',
  aiChat_matchUnavailableHint: 'ค้นหากลุ่มด้านล่าง หรือปิดแล้วเปิดการโพสต์อีกครั้ง',
  aiChat_waitSlowHint: 'ใช้เวลานานกว่าปกติ แต่ยังประมวลผลอยู่ โปรดรอสักครู่ หรือค้นหากลุ่มด้านล่าง',
  aiChat_creatingSlowHint: 'การสร้างกลุ่มใช้เวลานานกว่าปกติ แต่ยังทำงานอยู่ รอสักครู่ เสร็จแล้วโพสต์ต่อได้เลย',
  aiChat_pickChannelEmptyHint: 'ไม่พบกลุ่มที่เกี่ยวข้อง สร้างกลุ่มใหม่เพื่อโพสต์ข้อความของคุณ',
  aiChat_loadMore: 'โหลดเพิ่มเติม',
  sidebar_publish: 'โพสต์',
  chat_selectLocationOnMap: 'กรุณาเลือกตำแหน่งบนแผนที่',

  // App.vue new
  placeholder_email: 'กรุณากรอกอีเมล',
  placeholder_mobile: 'กรุณากรอกเบอร์โทรศัพท์',
  placeholder_password: 'กรุณากรอกรหัสผ่าน',
  placeholder_name: 'กรุณากรอกชื่อของคุณ',
  random_nickname: 'สุ่ม',
  placeholder_verification_code: 'กรุณากรอกรหัสยืนยัน',
  sending: 'กำลังส่ง...',
  registering: 'กำลังลงทะเบียน...',
  send_code: 'ส่งรหัส',
  retry_in_seconds: 'ลองอีกครั้งใน {countdown} วินาที',
  toast_enter_email: 'กรุณากรอกอีเมล',
  toast_enter_mobile: 'กรุณากรอกเบอร์โทรศัพท์',
  toast_invalid_email: 'กรุณากรอกรูปแบบอีเมลที่ถูกต้อง',
  toast_invalid_mobile: 'กรุณากรอกเบอร์โทรศัพท์ที่ถูกต้อง',
  toast_send_code_failed: 'ส่งรหัสยืนยันไม่สำเร็จ',
  toast_code_sent: 'ส่งรหัสยืนยันไปที่อีเมลแล้ว',
  toast_code_sent_sms: 'ส่งรหัสยืนยันไปที่โทรศัพท์แล้ว',
  toast_send_code_error: 'ส่งรหัสยืนยันไม่สำเร็จ กรุณาลองอีกครั้งภายหลัง',
  toast_fill_all_fields: 'กรุณากรอกข้อมูลให้ครบทุกช่อง',
  toast_login_failed: 'เข้าสู่ระบบไม่สำเร็จ',
  toast_login_success: 'เข้าสู่ระบบสำเร็จ',
  oauthOr: 'หรือ',
  toast_oauth_login_failed: 'เข้าสู่ระบบด้วย Google ไม่สำเร็จ',
  toast_oauth_login_error: 'เกิดข้อผิดพลาดในการเข้าสู่ระบบ Google กรุณาลองอีกครั้ง',
  toast_login_error: 'เข้าสู่ระบบไม่สำเร็จ กรุณาลองอีกครั้งภายหลัง',
  toast_register_failed: 'ลงทะเบียนไม่สำเร็จ',
  toast_register_success: 'ลงทะเบียนสำเร็จ',
  toast_register_error: 'ลงทะเบียนไม่สำเร็จ กรุณาลองอีกครั้งภายหลัง',

  // AdBanner.vue
  ad: 'โฆษณา',

  // ContactAdGate.vue 联系前广告闸门
  contactAd_gateTitle: 'ก่อนเชื่อมต่อ',
  contactAd_gateSubtitle: 'การพักสั้นๆ นี้ช่วยให้ OctoSay ใช้งานได้ฟรี — ขอบคุณที่สนับสนุนนะ!',
  contactAd_waitBtn: 'ดำเนินการต่อได้ใน {sec} วินาที',
  contactAd_continueBtn: 'ไปที่แชทต่อ',

  // ChannelDetail.vue 私聊按钮
  session_privateChat: 'แชท',

  // AiMatch.vue
  ai_welcome_msg: 'สวัสดี ฉันคือ AI เล่าสิ่งที่คุณคิดให้ฉันฟัง — หาเพื่อน หาคู่ แลกทักษะ หรืออะไรก็ได้',
  default_username: 'ผู้ใช้',

  // AvatarCropDialog.vue
  crop_hint: 'บีบเพื่อซูม ลากเพื่อปรับ',
  toast_crop_failed: 'ครอบตัดรูปไม่สำเร็จ',

  // ChatBox.vue
  loading_match_info: 'กำลังโหลดข้อมูลการจับคู่...',
  view_match_details: 'ดูรายละเอียดการจับคู่',
  step_clarify_needs: 'เคลียร์',
  step_ai_matching: 'โพสต์ลง กลุ่ม',
  step_connect: 'จับคู่ด้วย AI',
  make_private: 'ตั้งเป็นส่วนตัว',
  setting: 'กำลังตั้งค่า...',
  action_photo: 'รูปภาพ',
  action_file: 'ไฟล์',
  action_video: 'วิดีโอ',
  action_location: 'ตำแหน่งที่ตั้ง',
  hint_get_app: 'รับแอปเพื่ออยู่ด้วยกันต่อ',
  match_finding_title: 'คู่ของคุณ',
  match_finding_subtitle: 'AI กำลังจับคู่ให้คุณอย่างต่อเนื่อง',
  match_time_hint: 'กระบวนการนี้ปกติใช้เวลา 1-2 นาที',
  match_result_stats: 'พบแมตช์ที่ดีที่สุด {matched} รายการ{interested}',
  match_tap_to_connect: 'แตะเพื่อเริ่มบทสนทนา',
  match_channel_hint: 'กำลังจับคู่ใน hub <strong>#{channel}</strong> ให้ความสำคัญกับ hub เดียวกันก่อน แต่อาจรวม hub อื่นเมื่อจำเป็น',
  label_perfect_match: 'คู่ที่ดีที่สุด',
  label_worth_a_look: 'น่าสนใจ',
  match_no_result_title: 'กำลังหาคู่ให้คุณ',
  match_no_result_desc: 'แบ่งปันรายละเอียดเพิ่มเติมเพื่อช่วยให้ OctoSay หาคู่ที่ใช่ ติดตั้งแอปเพื่อรับการแจ้งเตือนเมื่อมีคนจับคู่กับคุณ',
  go_back: 'ย้อนกลับ',
  no_public_requirements: 'ยังไม่มีโพสต์สาธารณะ',
  channelEmpty_title: 'ที่นี่ยังเงียบอยู่',
  channelEmpty_subtitle: 'เป็นคนแรกที่แบ่งปันความคิด',
  channelEmpty_hint: "เขียนความคิดของคุณ แล้ว AI จะช่วยเคลียร์และจับคู่อย่างต่อเนื่อง เพื่อไม่ให้ข้อความของคุณจมหายไป",
  channelEmpty_action: 'แบ่งปันความคิดของคุณ',
  stay_connected: 'อยู่ด้วยกันต่อ',
  download_app_desc: 'รับแอปเพื่อแชท และรับการแจ้งเตือนทันทีเมื่อมีคนมาเชื่อมต่อกับคุณ!',
  app_store: 'App Store',
  google_play: 'Google Play',
  direct_apk: 'APK โดยตรง',
  match_history: 'ประวัติการจับคู่',
  no_match_history: 'ยังไม่มีประวัติการจับคู่',
  finding_matches: 'AI หาคู่ให้คุณอย่างต่อเนื่อง - หลังโพสต์ข้อความลง hub',
  discover_connect_hint: 'คุณสามารถแชทกับเขาได้เมื่อจับคู่แล้ว!',
  match_initializing: 'กำลังเริ่มต้น...',
  placeholder_login_to_chat: 'เข้าสู่ระบบเพื่อเล่าสิ่งที่คุณคิดให้ฉันฟัง',
  toast_need_clear: 'ความคิดของคุณชัดเจนแล้ว!',
  toast_ai_responding: 'AI กำลังตอบกลับ กรุณารอสักครู่...',
  toast_uploading_image: 'กำลังอัปโหลดรูป กรุณารอสักครู่...',
  toast_uploading_file: 'กำลังอัปโหลดไฟล์ กรุณารอสักครู่...',
  toast_max_photos: 'อนุญาตสูงสุด {max} รูป',
  toast_uploading: 'กำลังอัปโหลด กรุณารอสักครู่...',
  toast_file_too_large: '{name} เกินขีดจำกัด 5MB',
  toast_video_too_large: '{name} เกินขีดจำกัด 20MB',
  toast_video_processing: 'กำลังประมวลผลวิดีโอ กรุณารอสักครู่…',
  toast_upload_link_failed: 'ดึงลิงก์อัปโหลดไม่สำเร็จ',
  analyzing_image: 'กำลังวิเคราะห์รูปภาพ...',
  toast_location_confirmed: 'ยืนยันตำแหน่งแล้ว',
  toast_location_selected: 'เลือกตำแหน่งแล้ว',
  toast_enter_search: 'กรุณากรอกเนื้อหาที่ต้องการค้นหา',
  toast_search_failed: 'ค้นหาไม่สำเร็จ',
  toast_no_locations: 'ไม่พบตำแหน่ง',
  toast_search_error: 'ค้นหาไม่สำเร็จ กรุณาลองอีกครั้ง',
  toast_located_at: 'พบที่: {address}',
  toast_shared_finding: 'แชร์แล้ว! กำลังหาแมตช์...',
  toast_update_failed: 'อัปเดตไม่สำเร็จ',
  toast_set_private: 'ตั้งเป็นส่วนตัวแล้ว',
  toast_no_matches: 'ไม่พบแมตช์',
  toast_matches_found: 'พบแมตช์ที่ดีที่สุด {count} รายการ',
  toast_start_conversation_first: 'กรุณาเริ่มบทสนทนาก่อน',
  toast_load_history_failed: 'โหลดประวัติการจับคู่ไม่สำเร็จ',
  toast_ai_timeout: 'AI ใช้เวลานานเกินไป กรุณาลองอีกครั้ง',
  toast_message_blocked: 'ข้อความถูกบล็อก',
  network_disconnected: 'เครือข่ายขาดการเชื่อมต่อ',
  toast_publish_success: 'โพสต์ลง hub แล้ว!',
  toast_publish_failed: 'โพสต์ลง hub ไม่สำเร็จ',

  // ChatMsgList.vue
  collapse_thinking: 'ย่อกระบวนการคิด',
  expand_thinking: 'แสดงกระบวนการคิด',
  thinking: 'กำลังคิด',
  select_date: 'เลือกวันที่',
  selected_location: 'ตำแหน่งที่เลือก',
  msg_blocked: 'ถูกบล็อก',
  retry: 'ลองอีกครั้ง',
  msg_read: 'อ่านแล้ว',
  msg_sent: 'ส่งแล้ว',
  msg_unread: 'ยังไม่ได้อ่าน',
  label_start_datetime: 'วันเวลาเริ่มต้น:',
  label_end_datetime: 'วันเวลาสิ้นสุด:',
  toast_select_start_datetime: 'กรุณาเลือกวันที่และเวลาเริ่มต้น',
  toast_end_before_start: 'วันเวลาสิ้นสุดต้องไม่เร็วกว่าวันเวลาเริ่มต้น',
  report_message: 'รายงานข้อความ',
  block_user: 'บล็อกผู้ใช้',
  msg_revoke: 'เรียกคืน',
  msg_quote: 'อ้างอิง',
  msg_revoked_self: 'คุณเรียกคืนข้อความแล้ว',
  msg_revoked_other: 'อีกฝ่ายเรียกคืนข้อความแล้ว',
  // Neutral text inside quote block: the revoker is the sender of the quoted message, unrelated to current message direction
  msg_revoked_generic: 'ข้อความถูกเรียกคืน',
  // Platform removal (content moderation manual review), distinct from self-revoke
  msg_revoked_platform: 'ข้อความนี้ถูกถอนโดยแพลตฟอร์มเนื่องจากละเมิดกฎ',
  msg_blocked_label: 'This message was blocked by the platform',
  toast_revoke_success: 'เรียกคืนข้อความแล้ว',
  toast_revoke_failed: 'เรียกคืนข้อความไม่สำเร็จ',
  toast_load_data_failed: 'โหลดข้อมูลไม่สำเร็จ กรุณารีเฟรช',
  toast_file_url_missing: 'ไม่พบ URL ของไฟล์',
  toast_block_success: 'บล็อกผู้ใช้สำเร็จ',
  toast_block_failed: 'บล็อกผู้ใช้ไม่สำเร็จ',

  // ChatSession.vue
  no_more_records: 'ไม่มีบันทึกเพิ่มเติม',
  title_needs_clarified: 'ความคิดชัดเจนแล้ว',
  title_clarifying: 'กำลังช่วยเคลียร์ความคิด',
  title_public: 'สาธารณะ',
  title_private: 'ส่วนตัว',
  badge_clarified: 'เคลียร์แล้ว',
  badge_clarifying: 'กำลังเคลียร์',
  badge_only_me: 'เฉพาะฉัน',
  badge_expired: 'หมดอายุ',
  title_expired: 'หมดอายุ',
  no_chat_history: 'ไม่มีประวัติการแชท',

  // ContactMethods.vue
  block_status_banner: 'คุณได้บล็อกผู้ใช้นี้แล้ว',
  unblock_user: 'ปลดบล็อก',
  toast_block_missing_id: 'บล็อกไม่ได้: ไม่มีรหัสผู้ใช้',
  dialog_block_confirm: 'แน่ใจหรือไม่ว่าต้องการบล็อก {name}? คุณจะไม่ได้รับข้อความจากเขาอีก',
  toast_user_blocked: '{name} ถูกบล็อกแล้ว',
  toast_unblock_missing_id: 'ปลดบล็อกไม่ได้: ไม่มีรหัสผู้ใช้',
  toast_user_unblocked: '{name} ถูกปลดบล็อกแล้ว',

  // BlockedUsers.vue
  blocked_users: 'ผู้ใช้ที่บล็อก',
  blocked_users_empty: 'ยังไม่มีผู้ใช้ที่บล็อก',
  blocked_users_empty_hint: 'ผู้ใช้ที่บล็อกจะส่งข้อความหาคุณไม่ได้อีก',
  blocked_users_unblock: 'ปลดบล็อก',
  dialog_unblock_confirm: 'หลังปลดบล็อก เขาจะส่งข้อความหาคุณได้อีกครั้ง',
  toast_unblock_success: 'ปลดบล็อกแล้ว',
  toast_unblock_failed: 'ปลดบล็อกไม่สำเร็จ กรุณาลองอีกครั้ง',
  blocked_users_load_failed: 'โหลดไม่สำเร็จ แตะเพื่อลองอีกครั้ง',
  blocked_users_blocked_at: 'บล็อกเมื่อ {date}',
  blocked_users_unknown_user: 'ผู้ใช้ที่ไม่รู้จัก',

  // Contacts.vue
  no_connections: 'ยังไม่มีข้อความ',
  chat_with: 'แชทกับ {name}',
  toast_load_contacts_failed: 'โหลดรายชื่อติดต่อไม่สำเร็จ: {msg}',
  toast_load_contacts_error: 'โหลดรายชื่อติดต่อไม่สำเร็จ กรุณารีเฟรชและลองอีกครั้ง',
  time_just_now: 'เมื่อสักครู่',
  time_minutes_ago: '{min} นาทีที่แล้ว',
  time_hours_ago: '{hour} ชั่วโมงที่แล้ว',
  time_days_ago: '{day} วันที่แล้ว',

  // InteractionNotification.vue
  interaction_notification_title: 'การแจ้งเตือน',
  interaction_notification_subtitle: 'ความคิดเห็น & ถูกใจ',
  interaction_notification_empty: 'ยังไม่มีการแจ้งเตือน',
  interaction_notification_comment: 'แสดงความคิดเห็น: {content}',
  interaction_notification_like: 'ถูกใจโพสต์ของคุณ',
  interaction_notification_reply: 'ตอบกลับ: {content}',
  interaction_notification_bookmark: 'บุ๊กมาร์กโพสต์ของคุณ',
  toast_load_notifications_failed: 'โหลดการแจ้งเตือนไม่สำเร็จ: {msg}',
  toast_load_notifications_error: 'โหลดการแจ้งเตือนไม่สำเร็จ กรุณารีเฟรชและลองอีกครั้ง',
  mark_all_read: 'ทำเครื่องหมายว่าอ่านทั้งหมด',
  toast_mark_all_read_failed: 'ดำเนินการล้มเหลว กรุณาลองอีกครั้ง',
  contacts_dnd: 'ปิดเสียงการแจ้งเตือน',
  dnd_enabled: 'ปิดเสียงการแจ้งเตือนแล้ว',
  dnd_disabled: 'เปิดเสียงการแจ้งเตือนแล้ว',
  dnd_action_enable: 'ปิดเสียงการแจ้งเตือน',
  dnd_action_disable: 'เปิดเสียงการแจ้งเตือน',

  // Discover.vue
  toast_load_sessions_failed: 'โหลดเซสชันไม่สำเร็จ: {msg}',
  toast_load_sessions_error: 'โหลดเซสชันไม่สำเร็จ',
  discover_noMessages: 'ยังไม่มีข้อความ',

  // EmojiInputArea.vue
  placeholder_default: 'เล่ารายละเอียดเพิ่มให้ AI ฟัง',
  userChat_typeMessage: 'พิมพ์ข้อความ...',
  select_emoji: 'เลือกอิโมจิ',
  badge_new: 'ใหม่',
  channel_search_placeholder: 'กรอกแชนเนล',
  channel_picker_empty: 'กรอกแชนเนล',

  // FrontPage.vue
  tab_chat_with_ai: 'ให้ OctoSay เข้าใจคุณ',
  history_chats: 'ประวัติ',
  tab_connections: 'แมตช์',
  tab_conversations: 'ข้อความ',
  tab_profile: 'โปรไฟล์',
  new_session: 'ใหม่',
  history_tab_chats: 'ของฉัน',
  history_tab_matches: 'แมตช์',
  channels_octosay: 'กลุ่ม Octo',
  tab_matches: 'แมตช์',
  tab_messages: 'ข้อความ',

  // Header.vue
  slogan: 'OctoSay - AI ที่เข้าใจคุณและจับคู่คุณกับคนที่ใช่',
  app_name: 'OctoSay',
  slogan_short: 'AI ที่เข้าใจคุณและจับคู่คุณกับคนที่ใช่',
  slogan_ai: 'AI ที่เข้าใจคุณและจับคู่คุณกับคนที่ใช่',
  get_the_app: 'รับแอป',
  desc_iphone_ipad: 'iPhone / iPad',
  desc_android: 'Android',
  search_in_app_stores: 'หรือค้นหา OctoSay ใน app store',

  // MapLocationPicker.vue
  placeholder_search_location: 'ค้นหาตำแหน่ง...',
  coords_display: 'ลองจิจูด: {lng}, ละติจูด: {lat}',
  toast_no_geolocation: 'เบราว์เซอร์ของคุณไม่รองรับการระบุตำแหน่ง',
  toast_location_permission_denied: 'ดึงตำแหน่งของคุณไม่ได้ กรุณาตรวจสอบสิทธิ์การระบุตำแหน่ง',
  loading_address: 'กำลังโหลดที่อยู่...',

  // MatchedSession.vue
  created_at: 'สร้างเมื่อ: {time}',
  ai_match_analysis: 'การวิเคราะห์การจับคู่ของ AI',
  error_missing_session_params: 'ขาดพารามิเตอร์เซสชันที่จำเป็น',
  match_private_hint: 'เซสชันนี้เป็นส่วนตัว ไม่สามารถดูเนื้อหาได้',

  // PersonalCenter.vue
  label_name: 'ชื่อ:',
  placeholder_enter_name: 'กรอกชื่อของคุณ',
  label_bio: 'แนะนำตัว:',
  placeholder_enter_bio: 'เขียนบางอย่างเกี่ยวกับตัวคุณ',
  placeholder_bio_empty: 'บอกอะไรสักอย่างเกี่ยวกับตัวคุณ',
  bio: 'แนะนำตัว',
  delete_account: 'ลบบัญชี',
  delete_warning: 'การกระทำนี้ไม่สามารถย้อนกลับได้',
  delete_data_intro: 'ข้อมูลต่อไปนี้จะถูกลบอย่างถาวร:',
  delete_item_profile: 'ข้อมูลโปรไฟล์ของคุณ',
  delete_item_chat: 'ประวัติการแชทและเซสชัน',
  delete_item_contact: 'ข้อมูลผู้ติดต่อ',
  delete_item_all: 'ข้อมูลที่เกี่ยวข้องทั้งหมด',
  final_confirmation: 'ยืนยันขั้นสุดท้าย',
  delete_confirm_prompt: 'พิมพ์ "delete" เพื่อยืนยัน:',
  placeholder_type_delete: 'พิมพ์ delete',
  private_token: 'โทเค็นส่วนตัว',
  token_desc: 'สร้างโทเค็นสำหรับเข้าถึง API',
  toast_not_logged_in: 'ผู้ใช้ยังไม่ได้เข้าสู่ระบบ',
  toast_name_required: 'ต้องกรอกชื่อ',
  toast_save_success: 'บันทึกสำเร็จ',
  toast_save_failed: 'บันทึกไม่สำเร็จ',
  toast_image_too_large: 'รูปภาพเกินขีดจำกัด 5MB',
  toast_avatar_updated: 'อัปเดตรูปโปรไฟล์แล้ว',
  toast_avatar_failed: 'อัปเดตรูปโปรไฟล์ไม่สำเร็จ',
  toast_upload_failed: 'อัปโหลดไม่สำเร็จ',
  toast_token_generated: 'สร้างโทเค็นแล้ว',
  toast_token_failed: 'สร้างโทเค็นไม่สำเร็จ',
  toast_copied: 'คัดลอกไปยังคลิปบอร์ดแล้ว',
  toast_copy_failed: 'คัดลอกไม่สำเร็จ',
  toast_account_deleted: 'ลบบัญชีสำเร็จ',
  toast_delete_account_failed: 'ลบบัญชีไม่สำเร็จ',
  toast_logout_success: 'ออกจากระบบสำเร็จ',
  toast_logout_failed: 'ออกจากระบบไม่สำเร็จ',
  profile_tab_messages: 'ข้อความ',
  profile_tab_comments: 'ความคิดเห็น',
  profile_tab_likes: 'ถูกใจ',
  profile_tab_bookmarks: 'บุ๊กมาร์ก',
  profile_empty_messages: 'ยังไม่มีข้อความ',
  profile_empty_comments: 'ยังไม่มีความคิดเห็น',
  profile_empty_likes: 'ยังไม่มีการถูกใจ',
  profile_empty_bookmarks: 'ยังไม่มีบุ๊กมาร์ก',
  profile_reply_to: 'ตอบกลับ {name}',
  profile_stats_posts: 'ข้อความ',
  profile_stats_comments: 'ความคิดเห็น',
  profile_stats_likes: 'ถูกใจที่ได้รับ',
  profile_joined: 'เข้าร่วมเมื่อ {date}',

  // ReportDialog.vue
  report_message_title: 'รายงานข้อความ',
  report_reason_prompt: 'กรุณาเลือกเหตุผลในการรายงานข้อความนี้:',
  report_spam: 'สแปม',
  report_harassment: 'การคุกคามหรือกลั่นแกล้ง',
  report_inappropriate: 'เนื้อหาไม่เหมาะสม',
  report_other: 'อื่น ๆ',
  placeholder_report_desc: 'อธิบายปัญหา (ไม่บังคับ)',
  toast_select_reason: 'กรุณาเลือกเหตุผล',
  toast_report_success: 'ส่งรายงานสำเร็จ',
  toast_report_failed: 'ส่งรายงานไม่สำเร็จ',

  // common.js
  ellipsis: '..',

  // ChatBox.vue / ChatMsgList.vue message summary prefixes
  summary_image: '[รูปภาพ]',
  summary_images: '[รูปภาพ x{count}]',
  summary_file: '[ไฟล์]',
  summary_files: '[ไฟล์ x{count}]',
  summary_video: '[วิดีโอ]',
  summary_videos: '[วิดีโอ x{count}]',
  summary_location: '[ตำแหน่ง]',
  summary_locations: '[ตำแหน่งx{count}]',
  summary_emoji: '[อิโมจิ]',
  summary_emojis: '[อิโมจิ x{count}]',
  summary_voice: '[เสียง]',
  summary_voices: '[เสียงx{count}]',
  summary_mixed: '[หลายรูปแบบ]',
  summary_other: '[อื่น ๆ]',

  // Voice messages
  voice: 'เสียง',
  voice_recording: 'กำลังบันทึกเสียง...',
  toast_voice_too_short: 'บันทึกเสียงสั้นเกินไป',
  toast_voice_failed: 'ส่งข้อความเสียงไม่สำเร็จ',
  toast_mic_permission_denied: 'เข้าถึงไมโครโฟนไม่ได้ กรุณาเปิดสิทธิ์ในการตั้งค่าเบราว์เซอร์',
  toast_recording_not_supported: 'เบราว์เซอร์นี้ไม่รองรับการบันทึกเสียง',
  voice_load_failed: 'โหลดข้อความเสียงไม่สำเร็จ',

  // Expire At
  aiChat_expireLine: 'ใช้ได้ถึง {date} แจ้ง AI ได้ทุกเมื่อเพื่ออัปเดต',
  aiChat_expireExpired: 'เนื้อหาหมดอายุและไม่แสดงต่อผู้อื่นอีก แจ้ง AI ได้ทุกเมื่อเพื่ออัปเดตวันหมดอายุ',

  // MatchedSession.vue
  detail: 'รายละเอียด',

  // Match notification hints
  match_new_result_hint: 'หากมีผลการจับคู่ใหม่ คุณจะได้รับการแจ้งเตือน เพื่อประสบการณ์ที่ดีที่สุด ติดตั้งแอปเพื่อรับการแจ้งเตือนทันที',

  // Match notification hints
  match_connection_notify_hint: 'จับคู่สำเร็จและแจ้งเตือนแล้ว! ไปทักทายกันเลย!',
  match_continuousMatching: 'AI กำลังจับคู่ให้คุณอย่างต่อเนื่อง',
  match_continuousMatchingHint: 'จะบอกคุณทันทีเมื่อพบคู่ใหม่',
  match_continuousMatchingOthers: 'AI กำลังจับคู่ให้เขาอย่างต่อเนื่อง',
  match_continuousMatchingOthersHint: 'ผลใหม่จะแสดงที่นี่เมื่อพบ',
  match_noResultsTitleOthers: 'กำลังหาคู่ให้เขา',
  match_noResultsHintOthers: 'AI กำลังจับคู่ให้เขาอย่างต่อเนื่อง ผลจะแสดงที่นี่เมื่อพบ',
  match_newMatchFound: 'พบ {n} คู่ใหม่!',
  match_worth_exploring_hint: 'คุณเป็นคนตัดสินใจว่าจะทักไปหาหรือไม่',

  // Matches filter tags
  filter_all: 'ทั้งหมด',
  filter_best_connection: 'คู่ที่ดีที่สุด',
  filter_worth_a_look: 'น่าสนใจ',

  // LandingPage.vue (CN Portal)
  landing_brand_slogan: 'OctoSay - AI ที่เข้าใจคุณและจับคู่คุณกับคนที่ใช่',
  landing_hero_title: 'เขียนใน hub ของคุณ — AI เคลียร์ก่อน แล้วคุณเผยแพร่และจับคู่',
  landing_hero_subtitle: 'พิมพ์ข้อความที่ต้องการแชร์ใน กลุ่ม Octo ก่อนเผยแพร่ AI จะคุยกับคุณเพื่อเก็บรายละเอียด เมื่อคุณยืนยัน ข้อความและสรุปของ AI จะถูกโพสต์พร้อมกัน แล้ว AI เริ่มจับคู่ให้',
  landing_download_on: 'ดาวน์โหลดบน',
  landing_get_it_on: 'รับได้ที่',
  landing_direct_download: 'ดาวน์โหลดโดยตรง',
  landing_how_title: 'วิธีใช้งาน',
  landing_step1_title: 'เขียนใน กลุ่ม',
  landing_step1_desc: 'พิมพ์ข้อความที่คุณต้องการแชร์ใน hub AI จะคุยกับคุณก่อนเพื่อเคลียร์รายละเอียด ทำให้ทุกโพสต์ชัดเจน มีประโยชน์ และพร้อมจับคู่ — ไม่หายไปกับความวุ่นวาย',
  landing_step2_title: 'ยืนยัน โพสต์ & จับคู่',
  landing_step2_desc: 'เมื่อคุณยืนยัน ข้อความต้นฉบับและสรุปของ AI จะถูกโพสต์ลง hub พร้อมกัน จากนั้น AI จะหาคู่ที่เหมาะที่สุดให้อย่างต่อเนื่อง เพื่อให้ข้อความของคุณไม่จมหายไป',
  landing_step3_title: 'เชื่อมต่อ & คุยกัน',
  landing_step3_desc: 'เมื่อจับคู่สำเร็จ ทั้งสองฝ่ายจะเห็นประวัติการคุยกับ AI ของกันและกันและสรุปของ AI เมื่อมีบริบทร่วมกัน การเริ่มบทสนทนาจึงง่ายและเป็นธรรมชาติ',
  // Comparison Section
  landing_comparison_title: 'ทำไมต้อง OctoSay?',
  landing_comparison_subtitle: 'แชทแบบ hub แต่ AI เคลียร์รายละเอียดและจับคู่ให้คุณอย่างแข็งขัน',
  landing_comparison_other: 'Discord',
  landing_comparison_octo: 'OctoSay',
  landing_cmp1_label: 'คุณภาพเนื้อหา',
  landing_cmp1_other: 'สแปม โฆษณา และข้อความออกนอกหัวข้อล้นหน้า',
  landing_cmp1_octo: 'มีเฉพาะการ์ดความต้องการที่ AI คัดแล้ว',
  landing_cmp2_label: 'หาคน',
  landing_cmp2_other: 'โพสต์แล้วรอดูว่ามีใครเห็น',
  landing_cmp2_octo: 'AI จับคู่ให้คุณอย่างแข็งขัน',
  landing_cmp3_label: 'ระดับความรก',
  landing_cmp3_other: 'ต้องเลื่อนดูข้อความหลายร้อยข้อ',
  landing_cmp3_octo: 'ศูนย์ความรก ทุกโพสต์มีความหมาย',
  landing_cmp4_label: 'การเริ่มต้น',
  landing_cmp4_other: 'หาเซิร์ฟเวอร์ เลื่อนดูแชนเนล ศึกษาเอง',
  landing_cmp4_octo: 'พิมพ์ใน hub; AI เคลียร์และจับคู่ให้',
  landing_cmp_other_wechat: 'WeChat',
  landing_cmp_other_xhs: 'Xiaohongshu',
  landing_cmp_other_facebook: 'Facebook',
  landing_cmp_other_reddit: 'Reddit',
  landing_cmp1_wechat: 'แชทกลุ่มล้นไปด้วยโฆษณาและสแปม',
  landing_cmp1_xhs: 'โพสต์การตลาดเต็มไปหมด แยกไม่ออกว่าจริงหรือปลอม',
  landing_cmp1_facebook: 'โฆษณาและหัวข้อจี้หัวใจล้นฟีด',
  landing_cmp1_reddit: 'สแปมและโพสต์ออกนอกหัวข้อเต็มไปหมด',
  landing_cmp2_wechat: 'พึ่งรายชื่อติดต่อและการชวนเข้ากลุ่มเท่านั้น',
  landing_cmp2_xhs: 'ต้องค้นหาเองและไล่ดูโพสต์',
  landing_cmp2_facebook: 'จำกัดอยู่แค่เพื่อนและกลุ่มที่มีอยู่',
  landing_cmp2_reddit: 'ไล่ดู subreddit เองแล้วรอคำตอบ',
  landing_cmp3_wechat: 'เลื่อนดูข้อความกลุ่มหลายร้อยข้อ',
  landing_cmp3_xhs: 'ฟีดเต็มไปด้วยคำแนะนำและโฆษณา',
  landing_cmp3_facebook: 'โพสต์แนะนำและโฆษณาไม่มีวันจบ',
  landing_cmp3_reddit: 'ต้องเลื่อนดูความคิดเห็นหลายร้อยข้อ',
  landing_cmp5_label: 'ใครเป็นคนค้นหา',
  landing_cmp5_wechat: 'ถามทีละคน หวังดวง',
  landing_cmp5_xhs: 'โพสต์ รอคอมเมนต์ แล้วคัดกรองเอง',
  landing_cmp5_facebook: 'ต้องถามไปทั่วในกลุ่ม',
  landing_cmp5_reddit: 'โพสต์ รอคำตอบ แล้วคัดกรอง',
  landing_cmp5_octo: 'AI หาคนให้คุณอัตโนมัติอย่างต่อเนื่อง',

  landing_features_title: 'ฟีเจอร์หลัก',
  landing_feature1_title: 'เคลียร์ก่อนเผยแพร่',
  landing_feature1_desc: 'ไม่ต้องกรอกแบบฟอร์ม พิมพ์ข้อความใน hub แล้ว AI จะคุยกับคุณก่อน ถามคำถามที่ถูกจุด และเข้าใจความต้องการของคุณอย่างแท้จริง',
  landing_feature2_title: 'สะอาด ไม่วุ่นวาย',
  landing_feature2_desc: 'ข้อความและสรุปของ AI ถูกโพสต์พร้อมกัน — OctoSay คัดกรองทุกโพสต์ จึงไม่มีสแปม ไม่มีความวุ่นวาย ไม่ต้องเลื่อนหา',
  landing_feature3_title: 'จับคู่เชิงรุก',
  landing_feature3_desc: 'เมื่อคุณยืนยันและข้อความ + สรุป AI เผยแพร่แล้ว AI จะสแกน hub อย่างต่อเนื่องเพื่อหาคนที่ตรงกับสิ่งที่คุณมองหา — พร้อมอธิบายเหตุผล',
  landing_feature4_title: 'ชุมชนตามหัวข้อ ศูนย์ความรก',
  landing_feature4_desc: 'เข้าร่วม hub ตามหัวข้อ — กีฬา เกม แลกภาษา เพื่อนร่วมห้อง — AI เคลียร์ข้อความก่อนเผยแพร่ ทำให้ทุก hub สะอาดและมีประโยชน์',
  landing_feature5_title: 'คุ้มครองความเป็นส่วนตัว',
  landing_feature5_desc: 'ตั้งข้อความเป็นส่วนตัวหลังส่งได้ เห็นได้เฉพาะคุณ ควบคุมได้เต็มที่',
  landing_feature6_title: 'บทสนทนาที่มีความหมาย',
  landing_feature6_desc: 'ไม่มีความรก ไม่มีสิ่งรบกวน — ทุกข้อความมีความหมาย',
  landing_usecases_title: 'ใช้ได้กับทุกสถานการณ์',
  landing_usecases_subtitle: 'ไม่ว่าคุณกำลังคิดอะไร เข้าร่วม hub ตามหัวข้อ — AI จัดการเรื่องการจับคู่ให้ ไม่ต้องไล่เลื่อนและค้นหา',
  landing_usecase_game: 'เพื่อนเล่นเกม',
  landing_usecase_language: 'แลกภาษา',
  landing_usecase_skill: 'แลกทักษะ',
  landing_usecase_roommate: 'หาเพื่อนร่วมห้อง',
  landing_usecase_travel: 'เพื่อนเที่ยว',
  landing_usecase_sports: 'คู่ออกกำลังกาย',
  landing_usecase_study: 'คู่เรียน',
  landing_usecase_anything: '...หรือแชร์อะไรก็ได้',
  landing_cta_title: 'พร้อมเริ่มหรือยัง?',
  landing_cta_desc: 'เข้าร่วม hub ตามหัวข้อ เขียนสิ่งที่อยากแชร์ ให้ AI เคลียร์รายละเอียด จากนั้นเผยแพร่และจับคู่กับคนที่ใช่',
  landing_use_now: 'เริ่มใช้เลย',
  landing_groups: 'กลุ่ม',

  // OnboardingPage.vue
  onboarding_skip: 'ข้าม',
  onboarding_next: 'ถัดไป',
  onboarding_getStarted: 'เริ่มใช้งาน',
  onboarding_step1Title: "บอกความต้องการของคุณในกลุ่ม",
  onboarding_step1Desc: "ไม่ว่าคุณกำลังหาอะไรหรืออยากทำอะไร แค่บอกออกมา AI จะคุยกับคุณเพื่อเคลียร์รายละเอียด แล้วจัดเป็นข้อความที่ชัดเจน",
  onboarding_step2Title: 'ยืนยัน โพสต์ & จับคู่',
  onboarding_step2Desc: "เมื่อข้อความของคุณถูกโพสต์ลง hub แล้ว AI จะหาคู่ที่เหมาะที่สุดให้อย่างต่อเนื่อง เพื่อให้ข้อความของคุณไม่จมหายไป",
  onboarding_step3Title: 'เชื่อมต่อ & คุยกัน',
  onboarding_step3Desc: "ทั้งสองฝ่ายจะเห็นบทสนทนาของกันและกันกับ AI และรู้ว่าอีกฝ่ายต้องการอะไร เมื่อมีบริบทร่วมกัน การเริ่มบทสนทนาจึงง่ายและเป็นธรรมชาติ",

  // ChannelDetail.vue
  channel_image_limit: 'รูปสูงสุด 1 รูป',

  // ChannelMembers.vue
  channel_members_empty: 'ยังไม่มีสมาชิก',
  channel_members_title: 'สมาชิก',
  channel_role_owner: 'เจ้าของ',
  channel_role_admin: 'ผู้ดูแล',
  channel_role_member: 'สมาชิก',

  // Settings.vue
  settings_language: 'ภาษา',
  settings_language_followSystem: 'ตามระบบ',

  // ChatBox.vue
  match_interested_suffix: ', อีก {count} รายการน่าสนใจ',

  // ChatBox.vue - ขั้นตอนความคืบหน้าการจับคู่ AI
  match_stage_fetch_chat: 'กำลังดึงการสนทนา',
  match_stage_query_expansion: 'กำลังขยายคำค้นหา',
  match_stage_semantic_search: 'การค้นหาเชิงความหมาย',
  match_stage_deep_search: 'การวิเคราะห์เชิงลึก',
  match_stage_rerank: 'การจับคู่อัจฉริยะ',
  match_stage_refining: 'กำลังปรับปรุงผลลัพธ์',
  match_stage_fetch_details: 'กำลังดึงรายละเอียด',

  // ChannelDetail.vue - อัปโหลดรูปภาพ
  channel_select_image: 'กรุณาเลือกไฟล์รูปภาพ',
  channel_image_upload_failed: 'อัปโหลดรูปภาพไม่สำเร็จ โปรดลองอีกครั้ง',
  chatInput_channelSearchHint: "ค้นหากลุ่ม",
}



// WEBPACK FOOTER //
// ./src/i18n/th.js